export { default } from './zh-Hans';